module.exports = "/static/assets/d82da95d61c2bd2b7d3b8fa7815e1ae5.png";